import useCurrentUtcDate from "hooks/useCurrentUtcDate";
import { useEffect, useMemo } from "react";
import { SkuApprovalStatus } from "services/KnowfullyAdminClient";
import persistanceStore from "stores/persistanceStore";

type UseApprovalStatusFilterParams = {
  enabled: boolean;
  preSelectedQualificationIds?: string[];
  selectedQualificationIds: string[];
};

const useApprovalStatusFilter = ({
  enabled,
  preSelectedQualificationIds,
  selectedQualificationIds,
}: UseApprovalStatusFilterParams) => {
  const distinctPreSelectedQualificationIds = useMemo(
    () =>
      preSelectedQualificationIds
        ? Array.from(new Set(preSelectedQualificationIds))
        : undefined,
    [preSelectedQualificationIds]
  );
  const storedApprovalStatus = persistanceStore.useState(
    (state) => state.skuApprovalStatus
  );
  const effectiveQualificationIds =
    distinctPreSelectedQualificationIds ?? selectedQualificationIds;
  const isApplicable = enabled && effectiveQualificationIds.length > 0;
  const effectiveApprovalStatus = isApplicable
    ? storedApprovalStatus
    : undefined;
  const approvalStatusQueryDate = useCurrentUtcDate(
    effectiveApprovalStatus !== undefined
  );

  useEffect(() => {
    if (!isApplicable && storedApprovalStatus !== undefined) {
      persistanceStore.update((state) => {
        state.skuApprovalStatus = undefined;
      });
    }
  }, [isApplicable, storedApprovalStatus]);

  const setApprovalStatus = (approvalStatus?: SkuApprovalStatus) => {
    persistanceStore.update((state) => {
      state.skuApprovalStatus = approvalStatus;
    });
  };

  return {
    approvalStatusQueryDate,
    distinctPreSelectedQualificationIds,
    effectiveApprovalStatus,
    effectiveQualificationIds,
    isApprovalStatusApplicable: isApplicable,
    setApprovalStatus,
  };
};

export default useApprovalStatusFilter;
